export default __webpack_public_path__ + "static/media/Gradle.70d9a55a.svg";